import validator from "validator"
import {has, isEmpty, isString} from "lodash"

export default function doValidation({label, value, config}) {
  const validation = {
    firstname(iValue) {
      if (!isString(iValue)) { return false }
      return validator.isLength(iValue, {min: 2, max: 50})
    },
    lastname(iValue) {
      if (!isEmpty(iValue)) {
        return validator.isLength(iValue, {min: 2, max: 50})
      }
      return true
    },
    email(iValue) {
      if (!isString(iValue)) { return false }
      return validator.isEmail(iValue)
    },
    password(iValue) {
      return validator.isLength(iValue, {min: 8})
    },
    confirmpassword(iValue, iConfig) {
      return validator.equals(iValue, iConfig.comparison)
    },
    phone(iValue, iConfig) {
      if (iValue !== "") {
        return validator.isMobilePhone(iValue, iConfig.mobileRegion)
      }
      return true
    },
    dob(iValue) {
      const [year, month, day] = iValue.split("-")
      if (year !== "0000" && year !== "0001") {
        return !(day === "00" || month === "00")
      }
      return !((day !== "00" && month === "00") || (day === "00" && month !== "00"))
    },
    postcode(iValue) {
      if (iValue.length > 0) {
        const regex = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i
        return regex.test(iValue.replace(/\s/g, ""))
      }
      return true
    },
    color(iValue) {
      const regex = /^#(?:[0-9a-f]{3}){1,2}$/i
      return regex.test(iValue)
    }
  }


  if (has(config, "ignoreValidation", false) === false) {
    if (!(label.toLowerCase() in validation)) {
      return {value, isValid: false}
    }
    const isValid = validation[label.toLowerCase()](value, config)
    return {value, isValid}
  }
  return {value, isValid: true}
}
